import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import PATHS, { mergePaths } from 'utils/paths';

import ExtraCreditForEnterpriseForm from './ExtraCreditForEnterpriseForm';

const ExtraCredits = () => {
	const { pathname } = useLocation();

	const tabs = useMemo(
		() => [
			{
				label: 'SMBExtraCredits',
				path: mergePaths(PATHS.EXTRA_CREDITS, PATHS.EXTRA_CREDITS_SMB)
			},
			{
				label: 'EnterpriseExtraCredits',
				path: mergePaths(PATHS.EXTRA_CREDITS, PATHS.EXTRA_CREDITS_ENTERPISE)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/brand-icon.json.gz"
				title="extraCredits">
				{pathname === mergePaths(PATHS.EXTRA_CREDITS, PATHS.EXTRA_CREDITS_ENTERPISE) && (
					<Authorization path="/modal/extraFreeShipmentCredit">
						<Button
							lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
							label="addExtraCredit"
							onClick={() => NiceModal.show(ExtraCreditForEnterpriseForm, { mode: 'add' })}
							variant="blue"
							className="addButton"
						/>
					</Authorization>
				)}
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default ExtraCredits;
